export default __webpack_public_path__ + "static/media/Mobile_2.1c21a8f5.jpg";